<template lang="html">
<div>
    <el-upload ref="upload" list-type="picture-card" accept="image/*" :limit="limit" :on-exceed="handleExceed" :on-success="handleSuccess" :before-upload="beforeUpload" :file-list="fileList">
        <el-button size="small" type="primary">
            <span>点击上传</span>
        </el-button>
        <div slot="tip">只能上传 jpg/jpeg/png 文件，且不超过 2M {{tips}}</div>
        <div slot="file" slot-scope="{file}" class="demo1-1">
            <img class="imgs" :src="file.url" alt="">
            <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                </span>
                <!-- <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                    <i class="el-icon-download"></i>
                </span> -->
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                </span>
            </span>
        </div>
    </el-upload>
    <el-image-viewer v-if="showViewer" style="width: 100%; height: 100%" :on-close="closeViewer" :url-list="[imageUrl]">
    </el-image-viewer>
</div>
</template>

<script>
import {
    getToken
} from '@/utils/auth';
import {
    getFileToken,
    getViewKey,
    detFile
} from '@/api/account';
export default {
    model: {
        prop: "files", // 父组件设置v-model的变量值，v-model="message"
        event: "fileChange" // 父组件监听message事件
    },
    name: 'imgsUpload',
    props: ['files', 'limit', 'tips'],
    components: {
        'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
    },
    data() {
        return {
            fileList: [],
            postDat: '',
            disabled: false,
            viewDat: '',
            fileMap: {}, //缓存文件内容
            fileStore: [],
            imageUrl: '',
            srcList: [],
            showViewer: false,
        }
    },
    watch: {
        files: function (e) {
            if (e) {
                this.filesSet(e);
            }else{
                this.fileList=[];
                this.fileStore=[];
            }

        }
    },
    methods: {
        closeViewer() {
            this.showViewer = false;
            this.move();
        },
        handlePictureCardPreview(file) {
            this.imageUrl = file.url;
            this.srcList = [];
            for (var i = 0; i < this.fileList.length; i++) {
                this.srcList.push(this.fileList[i]['url']);
            }
            this.showViewer = true;
            this.stopMove();
        },
        filesSet: function (e) {
            console.log(e);
            var vues = this;
            if (this.fileList.length === 0 && e && this.viewDat) {

                var ids = e.split(',');
                var files = [];
                for (var i = 0; i < ids.length; i++) {
                    var file = {
                        id: ids[i],
                        name: ids[i],
                        url: vues.viewDat.imagePreUrl + '/id/' + ids[i] + '/token/' + vues.viewDat.token,
                    };
                    files.push(file);
                }
                this.fileList = files;
                this.fileStore = files;
                console.log(this.fileStore, this.fileList);
            }
        },
        beforeUpload: function (file) {
            console.log('beforeUpload');
            var isImage = file.type.split('\/')[0] === 'image';

            var isLt100M = file.size / 1024 / 1024 <= 2;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 2 MB!');
                return false;
            }

            if (!isImage) {
                this.$message.error('只能上传格式为 jpg/jpeg/png 的文件');
                return false;
            }

            if (isLt100M && isImage) {
                return true;
            }
        },
        // beforeUpload(file) {
        //     let _this = this
        //     return new Promise((resolve, reject) => {
        //         let isLt2M = file.size / 1024 / 1024 < 10 // 判定图片大小是否小于10MB
        //         if (!isLt2M) {
        //             reject()
        //         }
        //         let image = new Image(),
        //             resultBlob = '';
        //         image.src = URL.createObjectURL(file);
        //         image.onload = () => {
        //             // 调用方法获取blob格式，方法写在下边
        //             resultBlob = _this.compressUpload(image, file);
        //             resolve(resultBlob)
        //         }
        //         image.onerror = () => {
        //             reject()
        //         }
        //     })
        // },

        /* 图片压缩方法-canvas压缩 */
        compressUpload(image, file) {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            let initSize = image.src.length
            let {
                width
            } = image, {
                height
            } = image
            canvas.width = width
            canvas.height = height
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(image, 0, 0, width, height)

            // 进行最小压缩0.1
            let compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1)

            // 压缩后调用方法进行base64转Blob，方法写在下边
            let blobImg = this.dataURItoBlob(compressData)
            return blobImg
        },

        /* base64转Blob对象 */
        dataURItoBlob(data) {
            let byteString;
            if (data.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(data.split(',')[1])
            } else {
                byteString = unescape(data.split(',')[1])
            }
            let mimeString = data
                .split(',')[0]
                .split(':')[1]
                .split(';')[0];
            let ia = new Uint8Array(byteString.length)
            for (let i = 0; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i)
            }
            return new Blob([ia], {
                type: mimeString
            })
        },
        handleExceed(files, fileList) {
            console.log('handleExceed', files, fileList);
            this.$message.error('最多只能上传' + this.limit + '张图片！');
        },
        handleSuccess: function (res, file, fileList) {
            var newMap = {};
            fileList.forEach(item => {
                if (item.raw && item.raw.id) {
                    item.id = item.raw.id;
                }
                if (item.id) {
                    newMap[item.uid] = item.id;
                } else if (this.fileMap[item.uid]) {
                    newMap[item.uid] = this.fileMap[item.uid];
                }
            });
            newMap[file.uid] = this.postDat.key;
            this.fileMap = newMap;
            this.flieStoreSet(fileList);
        },
        //停止页面滚动
        stopMove() {
            let m = function (e) {
                e.preventDefault()
            }
            document.body.style.overflow = 'hidden'
            document.addEventListener("touchmove", m, {
                passive: false
            }) // 禁止页面滑动
        },
        //开启页面滚动
        move() {
            let m = function (e) {
                e.preventDefault()
            }
            document.body.style.overflow = 'auto' // 出现滚动条
            document.removeEventListener("touchmove", m, {
                passive: true
            })
        },
        handleRemove: function (file) {

            for (var i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].id == file.id) {
                    this.fileList.splice(i, 1);
                }
            }
            //   console.log(file,this.fileList);
            detFile({
                id: file.id,
                fileType: 1
            });
            this.flieStoreSet(this.fileList);
        },

        flieStoreSet: function (fileList) {
            this.fileStore = [];
            var ids = [];
            fileList.forEach(item => {
                var file = {
                    name: item.name,
                    id: item.id,
                }
                ids.push(item.id);
                this.fileStore.push(file);
            })
            this.$emit('change', this.fileStore);
            this.$emit('fileChange', ids.join(','));
        }

    },
    mounted: function () {
        let vm = this;
        var userInfo = this.$store.getters.userInfo;

        this.$refs.upload.$refs['upload-inner'].uploadFiles = function (files) {
            let svm = vm.$refs.upload.$refs['upload-inner'];
            if (svm.limit && svm.fileList.length + files.length > svm.limit) {
                svm.onExceed && svm.onExceed(files, svm.fileList);
                return;
            }
            let postFiles = Array.prototype.slice.call(files);
            if (!svm.multiple) {
                postFiles = postFiles.slice(0, 1);
            }
            if (postFiles.length === 0) {
                return;
            }

            getFileToken({
                userId: userInfo.userId,
                fileType: 1
            }).then(res => {
                vm.postDat = res;
                postFiles.forEach(rawFile => {
                    rawFile.id = res.key;
                    svm.onStart(rawFile);
                    rawFile.postUrl = vm.postDat.fileUploadUrl;
                    if (svm.autoUpload) svm.upload(rawFile);
                });
            });
        };

        this.$refs.upload.$refs['upload-inner'].post = function (rawFile) {
            const {
                uid
            } = rawFile;
            let svm = vm.$refs.upload.$refs['upload-inner'];
            let s = {
                token: getToken(),
                key: vm.postDat.key,
                fileSize: rawFile.size
            };
            const options = {
                headers: svm.headers,
                withCredentials: this.withCredentials,
                file: rawFile,
                data: s,
                filename: svm.name,
                action: rawFile.postUrl,
                onProgress: e => {
                    svm.onProgress(e, rawFile);
                },
                onSuccess: res => {
                    svm.onSuccess(res, rawFile);
                    delete this.reqs[uid];
                },
                onError: err => {
                    svm.onError(err, rawFile);
                    delete this.reqs[uid];
                }
            };
            const req = svm.httpRequest(options);
            svm.reqs[uid] = req;
            if (req && req.then) {
                req.then(options.onSuccess, options.onError);
            }
        };
    },
    created: function () {
        //初始化文件信息
        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl: res.imagePreUrl,
                token: res.token
            };
            if (this.files) {
                this.filesSet(this.files);
            }else{
                this.fileList=[];
                this.fileStore=[];
            }

        })
    }
}
</script>

<style lang="css" scoped>
.upload-img {
    width: 450px;
    padding-top: 2px;
}

.el-upload__tip {
    display: inline-block;
    margin-left: 12px;
}

.imgCard {
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border: 1px solid #F1F1F1;
    margin-top: 12px;
}

/* .demo1-1 {
      float: left;
      width: 200px;
      height: 200px;
    } */
.imgs {
    width: 148px;
    height: 148px;
    object-fit: cover;
}

.el-form-item.is-error .el-form-item__content .el-upload--picture-card {
    border-color: red;
}

.imgCard img {
    width: 120px;
    height: 120px;
}

.imgCard .pgress {
    margin: 15px;
}
</style>



// WEBPACK FOOTER //
// imgsUpload.vue?d39b4a92